import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('auth_url_oidc');

const OIDC_AUTHENTICATION_ENDPOINT = 'auth/v1/oidc';

export const OIDC_AUTHENTICATION_ENDPOINTS = {
  AUTHORIZE: `${OIDC_AUTHENTICATION_ENDPOINT}/authorize`,
  TOKEN: `${OIDC_AUTHENTICATION_ENDPOINT}/token`,
} as const;

export const BASE_URL = `${serverUrl}/${OIDC_AUTHENTICATION_ENDPOINT}`;

export const ERROR_TRACK_EVENTS = {};

export const OIDC_PROVIDER = {
  EMAIL: 'email',
  WORKOS: 'workos',
  GITHUB: 'github',
  GOOGLE: 'google',
  OIDC: 'oidc',
} as const;
